export const dateToText = (date: Date) => {
  const currentDate = new Date();
  return date.toLocaleDateString() === currentDate.toLocaleDateString();
};
